import { render } from "./CalendarLayout.vue?vue&type=template&id=d4d7f0a4"
import script from "./CalendarLayout.vue?vue&type=script&lang=ts"
export * from "./CalendarLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script